import { withInstall } from '@zoryn/utils'
import Select from './src/select.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZSelectV2: SFCWithInstall<typeof Select> = withInstall(Select)
export default ZSelectV2

export * from './src/token'
